export const FETCH_EMPLOYEE_PAYSLIPS = "FETCH_EMPLOYEE_PAYSLIPS";
export const FETCH_EMPLOYEE_PAYSLIPS_SUCCESS = "FETCH_EMPLOYEE_PAYSLIPS_SUCCESS";
export const FETCH_EMPLOYEE_PAYSLIPS_FAILURE = "FETCH_EMPLOYEE_PAYSLIPS_FAILURE";

export const RESET_SAVE_STATUS = "RESET_SAVE_STATUS";

export const FETCH_EMPLOYEE_WAGEREGISTER = "FETCH_EMPLOYEE_WAGEREGISTER";
export const FETCH_EMPLOYEE_WAGEREGISTER_SUCCESS = "FETCH_EMPLOYEE_WAGEREGISTER_SUCCESS";
export const FETCH_EMPLOYEE_WAGEREGISTER_FAILURE = "FETCH_EMPLOYEE_WAGEREGISTER_FAILURE";

export const FETCH_BANKSTATEMENT_DETAILS = "FETCH_BANKSTATEMENT_DETAILS";
export const FETCH_BANKSTATEMENT_SUCCESS = "FETCH_BANKSTATEMENT_SUCCESS";
export const FETCH_BANKSTATEMENT_FAILURE = "FETCH_BANKSTATEMENT_FAILURE";
export const CLEAR_BANKSTATEMENT_DETAILS = "CLEAR_BANKSTATEMENT_DETAILS";

export const FETCH_SECTION_WAGE_LIST = "FETCH_SECTION_WAGE_LIST";
export const FETCH_SECTION_WAGE_SUCCESS = "FETCH_SECTION_WAGE_SUCCESS";
export const FETCH_SECTION_WAGE_FAILURE = "FETCH_SECTION_WAGE_FAILURE";
export const CLEAR_SECTION_WAGE_LIST = "CLEAR_SECTION_WAGE_LIST";

export const FETCH_EMPLOYEE_CTCT_LIST = "FETCH_EMPLOYEE_CTCT_LIST";
export const FETCH_EMPLOYEE_CTCT_LIST_SUCCESS = "FFETCH_EMPLOYEE_CTCT_LIST_SUCCESS";
export const FETCH_EMPLOYEE_CTCT_LIST_FAILURE = "FETCH_EMPLOYEE_CTCT_LIST_FAILURE";

export const FETCH_MONTHLY_ESI_LIST = "FETCH_MONTHLY_ESI_LIST";
export const FETCH_MONTHLY_ESI_LIST_SUCCESS = "FETCH_MONTHLY_ESI_LIST_SUCCESS";
export const FETCH_MONTHLY_ESI_LIST_FAILURE = "FETCH_MONTHLY_ESI_LIST_FAILURE";
export const CLEAR_MONTHLY_ESI_LIST = "CLEAR_MONTHLY_ESI_LIST";

export const FETCH_MONTHLY_PF_LIST = "FETCH_MONTHLY_PF_LIST";
export const FETCH_MONTHLY_PF_LIST_SUCCESS = "FETCH_MONTHLY_PF_LIST_SUCCESS";
export const FETCH_MONTHLY_PF_LIST_FAILURE = "FETCH_MONTHLY_PF_LIST_FAILURE";
export const CLEAR_MONTHLY_PF_LIST = "CLEAR_MONTHLY_PF_LIST";

export const FETCH_PAYREG_SUMMARY_LIST = "FETCH_PAYREG_SUMMARY_LIST";
export const FETCH_PAYREG_SUMMARY_LIST_SUCCESS = "FETCH_PAYREG_SUMMARY_LIST_SUCCESS";
export const FETCH_PAYREG_SUMMARY_LIST_FAILURE = "FETCH_PAYREG_SUMMARY_LIST_FAILURE";
export const CLEAR_PAYREG_SUMMARY_LIST = "CLEAR_PAYREG_SUMMARY_LIST";

export const FETCH_GETPAY_EMPLOYEE_REPORT_LIST = "FETCH_GETPAY_EMPLOYEE_REPORT_LIST";
export const FETCH_GETPAY_EMPLOYEE_REPORT_LIST_SUCCESS = "FETCH_GETPAY_EMPLOYEE_REPORT_LIST_SUCCESS";
export const FETCH_GETPAY_EMPLOYEE_REPORT_LIST_FAILURE = "FETCH_GETPAY_EMPLOYEE_REPORT_LIST_FAILURE";
export const CLEAR_GETPAY_EMPLOYEE_REPORT_LIST = "CLEAR_GETPAY_EMPLOYEE_REPORT_LIST";

export const CLEAR_PAYSLIP_ERROR = "CLEAR_PAYSLIP_ERROR";